import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook to add canonical URL meta tag to page head
 * Prevents duplicate content issues in SEO
 * @param customUrl Optional custom canonical URL (defaults to current page)
 */
export const useCanonicalUrl = (customUrl?: string) => {
  const location = useLocation();

  useEffect(() => {
    const baseUrl = window.location.origin;
    const canonicalUrl = customUrl || `${baseUrl}${location.pathname}`;

    // Remove existing canonical tag if present
    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }

    // Create and add new canonical tag
    const link = document.createElement('link');
    link.rel = 'canonical';
    link.href = canonicalUrl;
    document.head.appendChild(link);

    return () => {
      // Cleanup on unmount
      link.remove();
    };
  }, [location.pathname, customUrl]);
};

export default useCanonicalUrl;
